/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const INJECTION_KEYS = {
    SNACK:        'snack',
    GLOBALSTATE:  'globalState',
    SESSIONSTATE: 'session'
}
export default INJECTION_KEYS